import type { ForwardedHTMLProps } from './types';

export type { ForwardedHTMLProps } from './types';

export function forwardProps<T extends Record<string, unknown>>(props: T): Partial<ForwardedHTMLProps> {
  const forwarded: Partial<ForwardedHTMLProps> = {};

  Object.keys(props).forEach((key) => {
    if (key.startsWith('data-') || key.startsWith('aria-')) {
      (forwarded as Record<string, unknown>)[key] = props[key];
    }
  });

  return forwarded;
}
